import { Provider } from './types';

export const getAuthProvider = () => Provider.IRW;
